'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLazyLoad = require('react-lazy-load');

var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showJumbotron: true
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      var styles = require('./Home.scss');
      var showJumbotron = this.state.showJumbotron;

      var lazyLoadOffset = 200;
      var campStyles = require('./../Camps/Camps.scss');
      var data = {
        campsDates: [{
          url: '/detske-tabory/4.-11.7.2026',
          title: 'Dětský tábor 4.-11.7.2026',
          subTitle: 'Dělej co tě baví',
          date: '4.-11.7.',
          rest: 0
        }, {
          url: '/detske-tabory/1.-8.8.2026',
          title: 'Dětský tábor 1.-8.8.2026',
          subTitle: 'Dělej co tě baví',
          date: '1.-8.8.',
          rest: 0
        }, {
          url: '/detske-tabory/8.-15.8.2026',
          title: 'Dětský tábor 8.-15.8.2026',
          subTitle: 'Dělej co tě baví',
          date: '8.-15.8.',
          rest: 50
        }],
        suburbanCampsDates: []
      };

      var campPhotos = {
        photo1: require('./detsky-tabor-1-1.jpg'),
        photo2: require('./detsky-tabor-1-2.jpg'),
        photo3: require('./detsky-tabor-1-3.jpg'),
        photo4: require('./detsky-tabor-1-4.jpg'),
        photo5: require('./detsky-tabor-1-5.jpg'),
        photo6: require('./detsky-tabor-1-6.jpg'),
        photo7: require('./detsky-tabor-1-7.jpg')
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.home },
          _react2.default.createElement(_reactHelmet2.default, { title: 'D\u011Btsk\xE9 t\xE1bory, p\u0159\xEDm\u011Bstsk\xE9 t\xE1bory a sportovn\xED p\u0159\xEDpravka', link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz' }] }),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('container', styles.jumbotron, showJumbotron ? styles.animated : '') },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-10 col-sm-offset-1' },
                _react2.default.createElement(
                  'h1',
                  null,
                  'D\u011Btsk\xE9 t\xE1bory a sportovn\xED p\u0159\xEDpravka'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'D\u011Bti do 14 let se s n\xE1m\xED u\u010D\xED z\xE1klad\u016Fm atletiky, gymnastiky a m\xED\u010Dov\xFDch sport\u016F. Pro d\u011Bti je v\u0161estrann\xFD pohybov\xFD rozvoj d\u016Fle\u017Eit\xFD stejn\u011B jako radost z pohybu. B\u011Bhem t\xE1bor\u016F a tr\xE9nink\u016F v p\u0159\xEDpravce d\u011Bti nep\u0159et\u011B\u017Eujeme. Sna\u017E\xEDme se je hravou formou posouvat a d\xE1t jim mo\u017Enost volby sportu v pozd\u011Bj\u0161\xEDm v\u011Bku.'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('col-xs-12', styles.jumboServices) },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/detske-tabory', title: 'D\u011Btsk\xE9 t\xE1bory', className: styles.green },
                  _react2.default.createElement(
                    'strong',
                    { className: 'nice' },
                    'D\u011Btsk\xE9 t\xE1bory'
                  ),
                  _react2.default.createElement(
                    'svg',
                    { xmlns: 'http://www.w3.org/2000/svg', width: '300px', height: '120px' },
                    _react2.default.createElement('path', { strokeWidth: '5px', d: 'M3,60 C5,10 20,3 150,10 270,10 295,3 297,60 296,115 290,115 150,110 12,117 10,112 3,60' })
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/sportovni-pripravka', title: 'Sportovn\xED p\u0159\xEDpravka', className: styles.lightBlue },
                  _react2.default.createElement(
                    'strong',
                    { className: 'nice' },
                    'Sportovn\xED p\u0159\xEDpravka'
                  ),
                  _react2.default.createElement(
                    'svg',
                    { xmlns: 'http://www.w3.org/2000/svg', width: '300px', height: '120px' },
                    _react2.default.createElement('path', { strokeWidth: '5px', d: 'M3,60 C5,10 20,3 150,10 270,10 295,3 297,60 296,115 290,115 150,110 12,117 10,112 3,60' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-10 col-sm-offset-1' },
              _react2.default.createElement(
                'h2',
                null,
                'Letn\xED d\u011Btsk\xE9 t\xE1bory 2026'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/detske-tabory', title: 'D\u011Btsk\xE9 t\xE1bory' },
                  'Letn\xED sportovn\xED t\xE1bory'
                ),
                ' po\u0159\xE1d\xE1me i v roce 2026. \u010Cek\xE1 na v\xE1s pestr\xE1 nab\xEDdka a proto v\u011B\u0159\xEDme, \u017Ee si vybere ka\u017Ed\xFD. ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/detske-tabory', title: 'D\u011Btsk\xE9 t\xE1bory' },
                  'V\xEDce informac\xED a dal\u0161\xED term\xEDny d\u011Btsk\xFDch t\xE1bor\u016F'
                ),
                '.'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container-fluid', styles.ratolest) },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: campPhotos.photo1, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: campPhotos.photo2, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: campPhotos.photo3, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: campPhotos.photo4, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: campPhotos.photo5, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: campPhotos.photo6, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: campPhotos.photo7, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container-fluid', styles.services) },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'h2',
                  null,
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/detske-tabory', className: styles.green },
                    'D\u011Btsk\xE9 t\xE1bory',
                    _react2.default.createElement(
                      'small',
                      null,
                      ', na kter\xE9 se d\u011Bti r\xE1dy vrac\xED'
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Zimn\xED d\u011Btsk\xE9 t\xE1bory se odehr\xE1vaj\xED v Kru\u0161n\xFDch hor\xE1ch nedaleko J\xE1chymova, letn\xED a podzimn\xED t\xE1bory prob\xEDhaj\xED v kr\xE1sn\xE9m prost\u0159ed\xED S\xE1zavy v na\u0161em resortu. Ubytov\xE1n\xED je v\u017Edy v hotelu, zaji\u0161t\u011Bna je pln\xE1 penze a doprava z Prahy a\u017E na m\xEDsto pobytu. ',
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/detske-tabory', className: styles.green },
                    'V\xEDce informac\xED'
                  )
                )
              )
            )
          ),
          _Content2.default.renderDates(campStyles, data.campsDates),
          _react2.default.createElement('div', { className: styles.spacer }),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'h2',
                  null,
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/sportovni-pripravka', className: styles.lightBlue },
                    'Sportovn\xED p\u0159\xEDpravka',
                    _react2.default.createElement(
                      'small',
                      null,
                      ', kde d\u011Bti sportuj\xED cel\xFD rok'
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'D\u011Bti u\u010D\xEDme z\xE1klad\u016Fm atletiky, gymnastiky a m\xED\u010Dov\xFDch sport\u016F. D\u016Fraz klademe p\u0159edev\u0161\xEDm na to, aby je pohyb bavil a vybudovaly si k n\u011Bmu pozitivn\xED vztah. Nespecializujeme se na \u017E\xE1dn\xFD konkr\xE9tn\xED sport, chceme, aby si d\u011Bti mohly v pozd\u011Bj\u0161\xEDm v\u011Bku vybrat sport, kter\xFD je bude bavit a p\u0159itom mohly t\u011B\u017Eit z komplexn\xED p\u0159\xEDpravy u n\xE1s. ',
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/sportovni-pripravka', className: styles.lightBlue },
                    'V\xEDce informac\xED'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'h2',
                  null,
                  'D\u011Bti si s n\xE1mi hraj\xED'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Na t\xE1borech hrajeme celot\xE1borov\xE9 hry, kdy jsou d\u011Bti rozd\u011Bleny do t\xFDm\u016F tak, aby se nau\u010Dili mlad\u0161\xED spolupracovat se star\u0161\xEDmi a star\u0161\xED se nau\u010Dili zodpov\u011Bdnosti za mlad\u0161\xED kamar\xE1dy. Hrajeme si i b\u011Bhem tr\xE9nink\u016F ve sportovn\xED p\u0159\xEDpravce, krom\u011B sofistikovan\u011Bj\u0161\xEDch her jsou nejobl\xEDben\u011Bj\u0161\xED "Rybi\u010Dky", "Na \u017Eraloka", "Baba" a dal\u0161\xED pohybov\xE9 hry, b\u011Bhem kter\xFDch se d\u011Bti uvoln\xED a za\u017Eij\xED radost z pohybu. Pro star\u0161\xED a zku\u0161en\u011Bj\u0161\xED p\u0159ipravujeme na ka\u017Ed\xFD tr\xE9nink r\u016Fznorod\xE9 hry v t\xFDmech, nap\u0159\xEDklad \u0161tafetov\xE9 z\xE1vody.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'h2',
                  null,
                  'Zdrav\xFD \u017Eivotn\xED styl d\u011Bt\xED'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Db\xE1me na zdrav\xFD \u017Eivotn\xED styl d\u011Bt\xED, kter\xFD za\u010D\xEDn\xE1 spr\xE1vn\xFDm prota\u017Een\xEDm p\u0159ed pohybovou aktivitou a kon\u010D\xED kompenza\u010Dn\xEDmi cvi\u010Den\xEDmi po sportov\xE1n\xED. D\u011Bti, kter\xE9 maj\xED smyslupln\xE9ho kon\xED\u010Dka a v\u011Bnuj\xED se mu se z\xE1palem, se sp\xED\u0161 vyhnout drog\xE1m a alkoholu ve v\u011Bku pozd\u011Bj\u0161\xEDm. Na\u0161\xEDm posl\xE1n\xEDm je otev\u0159\xEDt d\u011Btem dve\u0159e do r\u016Fzn\xFDch sportovn\xEDch odv\u011Btv\xED, aby nesed\u011Bly doma nebo se nepoflakovaly venku a ned\u011Blaly hlouposti. Chceme aby d\u011Bti v\u011Bd\u011Bly jak \u017E\xEDt, tr\xE1vit voln\xFD \u010Das a m\u011Bly odpov\u011Bdnost za vlastn\xED zdrav\xED.'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Home;
}(_react.Component);

exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1108
// module chunks = 0